import { DatePipe } from '@angular/common';
import { Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { Helpers } from '../../../../app/helpers';
import { ITableModel } from '../../components/table/model/tableModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class MastersService implements OnInit {
  FuelPriceStatusList: any[] = [];
  TransportNameList: any[] = [];
  bodyTypeList: any = []
  totalReasonCount: number = 0;
  tableDetails: ITableModel;
  start: number = 0;
  Length: number = 20;
  searchValue: string = '';
  ChargeTypeList: any = [];
  IntraState: any = [];
  OutSideyourState: any = [];
  TransportServiceList: any = [];
  chTDSMasterList: any = [];
  TenantId: any; length: number = 20
  filterObj: any = {
    FuelPriceStatus: '',
  };
  totalfuelcount: number = 0;
  Fuelpump: any = [];
  CityName: any = []
  FuelCity: any = [];
  mangetdsStatusList: any[] = [];
  SubVehicleTypeList: any = []

  constructor(private _appService: appService, private translate: TranslateService, private decryptpipe: DecryptPipe, private cookieService: CookieService,
    private toastr: ToastrService, private datePipe: DatePipe, private modalService: NgbModal) { }
  ngOnInit(): void {
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    console.log(this.TenantId)
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
  }

  GetTransportType(TenantId: any): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetById("BusinessType", "GetTransportName", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.Transport;
                x.value = x.id;
              })
            }
            this.TransportNameList = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  GetReason(start: number = this.start, Length: number = this.Length, searchValue = this.searchValue) {

    Helpers.setLoading(true);
    this._appService.Post('ReasonMaster', 'GetReason', { start, Length, searchValue }).subscribe(
      (response) => {
        if (response) {
          this.totalReasonCount = response.length;
          // console.log('Total number of records:', this.totalReasonCount);
        }
        console.log(response);
        this.tableDetails.data = response;
        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(
          this.translate.instant("NewReasonMaster.ErrorfetchingReason", 'Error'),
          "error"
        );
      }
    );
  }

  GetChargeType(TenantId: any): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetById("Charge", "GetChargeType", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.ChargeType;
                x.value = x.id;
              })
            }
            this.ChargeTypeList = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  GetGSTTaxGroup(): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .Get("Charge", "GetGSTGroupList")
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.Label;
                x.value = x.Id;
              })
            }
            this.IntraState = response;
            this.OutSideyourState = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  GetTransportService(TenantId: any): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetById("Charge", "GetTransportMethod", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.TransporterName;
                x.value = x.id;
              })
            }
            this.TransportServiceList = response;
            resolve(response);
            console.log('Response', this.TransportServiceList)
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  GetAccountList(param): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("ChartsofAccount", "GetAccountListforCharges", param, 1)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
            reject(err);
          }
        );
    })
  }

  GetTDSListForCharge(): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .Get("Charge", "ch_GetTDSListForCharge")
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            this.chTDSMasterList = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  GetFuelpriceStatus() {
    return this.FuelPriceStatusList = [{ value: null, name: 'All' }, { value: 1, name: 'Active' }, { value: 0, name: 'InActive' }]
  }

  deleteFuelData(Id): Promise<any> {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this entity type?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("FuelPrice", "DeleteFuelprice", Id).subscribe(response => {
            let resSTR = JSON.stringify(response);
            let resJSON = JSON.parse(resSTR);
            this.toastr.success(
              "Detail Deleted Successfully !",
              "Success"
            );
            resolve(1);
            Helpers.setLoading(false);
          }, err => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured while deleting data !", 'error');
          });
        }
        dialogRef.close();
      });
    })
  }

  GetFuelList(start: number = this.start, length: number = this.length, filterObject: any = this.filterObj, tenantid: any = this.TenantId, searchValue = this.searchValue) {
    this._appService.Post('FuelPrice', 'GetFuelDatas', {
      start,
      length,
      tenantid,
      searchValue,
      isActive: filterObject.FuelPriceStatus
    }).subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.totalfuelcount = response[0].TotalCount;
          response.map(x => {
            x.IsActiveString = x.IsActive ? 'InActive' : 'Active';
          });
          //console.log('Total fuel count:', this.totalfuelcount);
        }
        // console.log(response);
        this.tableDetails.data = response;
        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error("error");
      }
    );
  }

  Getfuelpricepumpwise(start: number = this.start, length: number = this.Length, searchValue = this.searchValue) {
    this._appService.Post('FuelPrice', 'GetFuelPricePumpWiseData', {
      start,
      length,
      searchValue
    }).subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.totalfuelcount = response[0].TotalCount;
        }
      },
      (err) => {
        this.toastr.error("error");
      }
    );
  }

  getFuelPumpName(CompanyId: any, UserId: any) {

    this._appService.GetByTwoId("FuelPrice", "fpp_getFuelPumpList", CompanyId, UserId).subscribe(
      (response) => {
        if (response) {
          response.map((x) => {
            x.name = x.fuelPumpName;
            x.value = x.fuelPumpId;
          });
        }
        this.Fuelpump = response
        console.log(this.Fuelpump, 'Fuelpumps')
      },

      (err) => {
        this.toastr.error("Error occurred while fetching Status data!", "Error");
      }
    );
  }

  getcityname() {
    this._appService.Get('FuelPrice', 'GetCityName').subscribe(
      (response) => {
        if (response) {
          response.map(x => {
            x.name = x.CityName;
            x.value = x.CityId;
          })
        }
        this.FuelCity = response
        this.CityName = { ...this.CityName, dropdownList: response };
        console.log(this.CityName, 'CityName')
      },
      (err) => {
        console.log("Error Occured", err)
      }
    )
  }
  AssociatedWith: any

  // GetTaxExemptions() {

  //   this._appService.GetById("Common", "GetLookByCategoryName", "TaxExemptions").subscribe(response => {
  //     this.AssociatedWith = response;

  //   }, err => {
  //     // this.toastr.error("Error occurred while fetching TaxExemptions !", 'error');
  //   });
  // }


  GetTaxExemptions() {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "TaxExemptions")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }

            this.AssociatedWith = response
            this.AssociatedWith = { ...this.AssociatedWith, dropdownList: response };

            // Logging the IDs
            // if (this.AssociatedWith) {
            //   this.AssociatedWith.forEach((item) => {
            //     console.log(item.Id); // Assuming the ID field is named 'Id'
            //   });
            // }

            // resolve(this.AssociatedWith);
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Reason Data !",
              "error"
            );
            reject(err);
          }
        );
    });
  }
  TotalTaxCount: any

  Gettaxexemptiondata(start = this.start, length = this.length, searchValue = this.searchValue, filterObject: any = this.filterObj) {
    this._appService.Post('TaxExemptions', 'GetNewTaxExemptionData', {
      start,
      length,
      searchValue,
      Label: filterObject.Label
    }).subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.TotalTaxCount = response[0].TotalCount;
        }
        response.map(x => {
          x.IsActiveString = x.IsActive ? 'Active' : 'InActive';
        });

        console.log(response);
        this.tableDetails.data = response;
        Helpers.setLoading(false);
      },
      (err) => {

      }
    );
  }

  deleteTaxById(Id): Promise<any> {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this Tax?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("TaxExemptions", "GetTaxExemptionsDelete", Id).subscribe(response => {
            let resSTR = JSON.stringify(response);
            let resJSON = JSON.parse(resSTR);
            this.toastr.success(
              "Detail Deleted Successfully !",
              "Success"
            );
            resolve(1);
            Helpers.setLoading(false);
          }, err => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured while deleting data !", 'error');
          });
        }
        dialogRef.close();
      });
    })
  }

  deleteReason(Id): Promise<any> {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: this.translate.instant("NewReasonMaster.Surewanttodelete"),
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("ReasonMaster", "DeleteReason", Id).subscribe(response => {
            let resSTR = JSON.stringify(response);
            let resJSON = JSON.parse(resSTR);
            this.toastr.success(
              this.translate.instant("NewReasonMaster.ReasonDeleted"),
              this.translate.instant("NewReasonMaster.Success")
            );
            resolve(1);
            Helpers.setLoading(false);
          }, err => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured while deleting data !", 'error');
          });
        }
        dialogRef.close();
      });
    })
  }
  GetExpenseCharge(param, CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("Charge", "getTripExpenseCharge", param, CompanyId)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
            reject(err);
          }
        );
    })
  }
  GetTdsStatus() {
    return this.mangetdsStatusList = [{ value: '', name: 'All' }, { value: 1, name: 'Active' }, { value: 0, name: 'InActive' }]
  }
  deleteTdsById(Id): Promise<any> {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: this.translate.instant("NewManageTax.DeleteWarning"),
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("ManageTDS", "GetTDSDelete", Id).subscribe(response => {
            let resSTR = JSON.stringify(response);
            let resJSON = JSON.parse(resSTR);
            this.toastr.success(
              this.translate.instant("NewManageTax.TdsDeleteMessage"),
              "Success"
            );
            resolve(1);
            Helpers.setLoading(false);
          }, err => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured while deleting data !", 'error');
          });
        }
        dialogRef.close();
      });
    })
  }
  GetBodyType() {
    return new Promise((resolve, reject) => {
      this._appService
        .Get("Vahicle", "GetBodyType")
        .subscribe(
          (response) => {
            console.log(response);
            if (response.length > 0) {
              response.map(x => {
                x.name = x.Name;
                x.value = x.BodyTypeId;
              })
            }
            this.bodyTypeList = response
            this.bodyTypeList = { ...this.bodyTypeList, dropdownList: response };
            resolve(response);
          },
          (err) => {
            this.toastr.error(
              "Error occurred while Bodytype data!",
              "error"
            );
            reject(err);

          }
        );
    });
  }

  deleteVehicle(Id): Promise<any> {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this Vehicle?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Vahicle", "DeleteVehicleData", Id).subscribe(response => {
            let resSTR = JSON.stringify(response);
            let resJSON = JSON.parse(resSTR);
            this.toastr.success(
              "Detail Deleted Successfully !",
              "Success"
            );
            resolve(1);
            Helpers.setLoading(false);
          }, err => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured while deleting data !", 'error');
          });
        }
        dialogRef.close();
      });
    })
  }
  UserId: any;
  DeleteFuelPump(Id, UserId): Promise<any> {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: this.translate.instant("NewFuelPrice.Surewanttodelete"),
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {

          Helpers.setLoading(true);
          this._appService.GetByTwoId("FuelPrice", "fpp_deleteFuelPrice", Id, UserId).subscribe(response => {
            let resSTR = JSON.stringify(response);
            let resJSON = JSON.parse(resSTR);
            this.toastr.success(
              this.translate.instant("NewFuelPrice.fuelpumppriceDeleted"),
              this.translate.instant("NewReasonMaster.Success")
            );
            resolve(1);
            Helpers.setLoading(false);
          }, err => {
            var deleteerror = this.translate.instant("NewFuelPrice.DeleteError")
            Helpers.setLoading(false);
            this.toastr.error(deleteerror, 'error');
          });
        }
        dialogRef.close();
      });
    })
  }

  GetSubVehicleType() {
    return new Promise((resolve, reject) => {
      this._appService
        .Get("Vahicle", "GetSubVehicleType")
        .subscribe(
          (response) => {
            console.log(response);
            if (response.length > 0) {
              response.map(x => {
                x.name = x.Name;
                x.value = x.BodyTypeId;
              })
            }
            // this.SubVehicleTypeList = response
            // this.SubVehicleTypeList = { ...this.SubVehicleTypeList, dropdownList: response };
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while SubVehicleType data!",
              "error"
            );
            reject(err);

          }
        );
    });
  }

  //added by vithu 03-03-2035
  GetAccountListIncome(param): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("ChartsofAccount", "GetAccountListforIncome", param, 1)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
            reject(err);
          }
        );
    })
  }

  GetAccountListExpense(param): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("ChartsofAccount", "GetAccountListforExpense", param, 1)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
            this.toastr.error(OwnershipError, "error");
            reject(err);
          }
        );
    })
  }
}
